import { apiClient } from 'lib/api';
import { useMutation } from '@tanstack/react-query';
import type { MutationConfig } from 'lib/react-query';
import type { EmergencyParams } from './types';
import type { Network } from 'types/shared';
import getApiPrefix from 'utils/getApiPrefix';
import { trackEmergencyToggle } from 'lib/datadog';

interface EmergencyError {
  message: string;
}

export const toggleEmergency = async (
  body: EmergencyParams,
  network: Network
): Promise<EmergencyParams | EmergencyError> => {
  const apiNetwork = getApiPrefix(network);
  const res = await apiClient.post<EmergencyParams>(`${apiNetwork}/emergency`, body);
  return res.data;
};

interface UseToggleEmergencyOptions {
  network: Network;
  config?: MutationConfig<typeof toggleEmergency>;
}

export const useToggleEmergency = ({ network, config }: UseToggleEmergencyOptions) => {
  return useMutation({
    ...config,
    onSuccess: async (...args) => {
      trackEmergencyToggle({ network, status: args[1].status });
      if (config?.onSuccess) {
        await config.onSuccess(...args);
      }
    },
    onError: (...args) => {
      if (config?.onError) {
        config.onError(...args);
      }
    },
    mutationFn: (params) => toggleEmergency(params, network),
  });
};
